import { render, staticRenderFns } from "./TpcDialog.vue?vue&type=template&id=9690d366&scoped=true"
import script from "./TpcDialog.vue?vue&type=script&lang=js"
export * from "./TpcDialog.vue?vue&type=script&lang=js"
import style0 from "./TpcDialog.vue?vue&type=style&index=0&id=9690d366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9b90bd239842d9ab132761d251f24808/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9690d366",
  null
  
)

export default component.exports